import FormAddressFields from '../../FormAddressFields';
import { type FormCustomQuestionProps } from '../types';

const AddressQuestion = ({ name, label, helpText, isRequired }: FormCustomQuestionProps) => (
  <FormAddressFields
    label={label}
    helpText={helpText}
    isRequired={isRequired}
    getFieldName={(prop) => `${name}.${prop}`}
  />
);

export default AddressQuestion;
